export const CREATE_TRIAGE_AGENT_CONFIGURATION_TEXT = 'Customize the agent'
export const CONFIG_FILE_NOT_FOUND_TEXT = 'Add custom instructions (optional)'
export const CONFIG_FILE_FOUND_TEXT = 'Edit custom instructions'
export const PAUSE_AGENT_TEXT = 'Pause the agent'
export const RESUME_AGENT_TEXT = 'Start the agent'
export const VIEW_DOCUMENTATION_TEXT = 'View documentation'
export const TRIAGE_AGENT_TITLE = 'Triage agent'
export const TRIAGE_AGENT_DOCS_URL = 'https://github.com/github/triage-agent/discussions/198'
export const TRIAGE_AGENT_PERMISSION_MESSAGE =
  'The Triage agent can be managed by users with the Maintainer role or higher.'
export const DEBUG_TRIAGE_TEXT = 'Debug triage'
export const DEBUG_TRIAGE_DESCRIPTION = 'Test and tweak triage prompts'

export type TriageState = 'inactive' | 'active'

export type TriagePath = 'capi' | 'twirp'

export const TRIAGE_BUTTON_TEXT: Record<TriageState, string> = {
  inactive: 'Enable triage',
  active: 'Triage agent',
}
